import Phaser from "phaser";

/**
 * A base class for scenes that need to handle scaling events.
 */
export abstract class DynamicScene extends Phaser.Scene {
  protected isReady: boolean = false;

  constructor(sceneConfig: string | Phaser.Types.Scenes.SettingsConfig) {
    super(sceneConfig);
  }

  init(): void {
    this.scale.on(
      Phaser.Scale.Events.RESIZE,
      (gameSize: Phaser.Structs.Size) => {
        if (!this.isReady) return;

        // Update the camera viewport and resize the camera manager
        this.cameras.main.setViewport(0, 0, gameSize.width, gameSize.height);
        // Update renderer size
        this.sys.game.renderer.resize(gameSize.width, gameSize.height);

        this.repositionElements(gameSize.width, gameSize.height);
      },
      this,
    );

    // clean up when the scene stops or is destroyed
    this.events.once(Phaser.Scenes.Events.SHUTDOWN, this.cleanup, this);
    this.events.once(Phaser.Scenes.Events.DESTROY, this.cleanup, this);
  }

  private cleanup(): void {
    this.scale.off(Phaser.Scale.Events.RESIZE);
  }

  abstract repositionElements(width?: number, height?: number): void;
}
